import { render, staticRenderFns } from "./UploadMultipleFile.vue?vue&type=template&id=4a0c90fb&scoped=true"
import script from "./UploadMultipleFile.vue?vue&type=script&lang=js"
export * from "./UploadMultipleFile.vue?vue&type=script&lang=js"
import style0 from "./UploadMultipleFile.vue?vue&type=style&index=0&id=4a0c90fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c90fb",
  null
  
)

export default component.exports